export const calcAge = (dateOfBirth: string): number => {
    // Used a regex for a guard clause, because date.parse() will return an age without a year selected
    const validDate = RegExp(/^(\d){4}-(\d){2}-(\d){2}$/);
    if (!validDate.test(dateOfBirth)) return NaN;
    try {
        const dobInMs = Date.parse(dateOfBirth);
        const todaysDateInMs = Date.now();
        const ageInMs = todaysDateInMs - dobInMs;
        const ageInYears = (new Date(ageInMs).getFullYear() - 1970);
        return ageInYears;
    } catch (error) {
        return NaN; // if no age can be determined. Assume the user is not a minor
    }
};
